import {doc} from './docs.js';
import {newSpore} from 'nft/spore.js';
import {BANG} from 'zobject/data-types.js';

doc(
    'spore',
    {
        "spore hash": "ipfs hash of new spore sound",
        "tokenID": "tokenID of spores.vision ERC720"
    },
    "Creates a new spore",
    () => 1,
    {
        inlets: 2
    }
);
export const spore = (object, tokenID) => {
    return ([sporeHash]) => {
        newSpore(sporeHash, tokenID()).then(
            transactionHash => {
                object.sendMessage(
                    object.outputByNumber(0),
                    transactionHash);
            });
    };
};
